document.addEventListener('DOMContentLoaded', function () {

    console.log("Custom Text Option Available");

    var selectedText, variantId, bumperType, font = 'blkout';

    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
        let [ resource, config ] = args;

        if ( resource === '/cart/add.js' ) {

            var cartJson = JSON.parse(config.body);
            const searchIndex = cartJson.items.findIndex((item) => item.id == variantId);

            if ( searchIndex >= 0 ) {

                const parentIndex = cartJson.items.findIndex((item) => item.properties.hasOwnProperty('_companions'));
                const uuid = uuidv4();
                cartJson.items[parentIndex].properties._text_uuid = uuid;
                cartJson.items[searchIndex].properties._text_uuid = uuid;
                cartJson.items[searchIndex].properties._text_url = imageUrlBuilder(bumperType, font, selectedText) + '?config=true';
                config.body = JSON.stringify(cartJson);
            }
        }

        return await originalFetch(resource, config);
    };


    $("head").append("<script src='https://cdn.jsdelivr.net/npm/sweetalert2@11.7.3/dist/sweetalert2.all.min.js'></script>");
    $("head").append("<link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/sweetalert2@11.7.3/dist/sweetalert2.min.css' type='text/css' media='screen'>");
    $("head").append("<link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css' type='text/css' media='screen'>");
    $("head").append("<link rel='stylesheet' href='//www.movebumpers.com/cdn/shop/t/210/assets/custom-text.css?v=160660849219957139521733475639' type='text/css' media='screen'>");


    $(".custom-text-radio").on("change", function () {

        if ( $(this).data('variant') === "Yes" ) {

            variantId = $(this).val();
            var title = $(this).data('title');
            customTextSteps(title);
        } else {

            selectedText, variantId, bumperType, font = 'blkout';
            $("#customTextSelected").html("");
        }


        /*
        variantId = $(this).find("option:selected").val();
        var selected = $(this).find("option:selected").text();
        var title = $(this).data('title');

        if ( selected.includes('Yes') ) {
            customTextSteps(title);
        } else {
            selectedText, variantId, bumperType, font = 'blkout';
            $("#customTextSelected").html("");
        }
        */
    })


    $(".custom-text").on("change", function () {


        var selected = $(this).find("option:selected").text();

        if ( selected.includes('Yes') ) {
            variantId = $(this).find("option:selected").val();
            var title = $(this).data('title');
            customTextSteps(title);
        } else {
            selectedText, variantId, bumperType, font = 'blkout';
            $("#customTextSelected").html("");
        }
    })

    async function customTextSteps(title) {

        bumperType = title.replace(/ .*/, '').toLowerCase();

        const steps = [ '1', '2', '3' ]

        const Queue = Swal.mixin({
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            position: 'middle',
            progressSteps: steps,
            confirmButtonColor: '#141719',
            showClass: {
                backdrop: 'swal2-noanimation',
                popup: '',
                icon: ''
            },
            hideClass: {
                popup: '',
            }

        })

        const { value: text } = await Queue.fire({
            title: `${ title } Builder`,
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            input: 'text',
            inputAttributes: {
                oninput: 'this.value = this.value.toUpperCase();'
            },
            inputLabel: 'Enter Your Custom Text',
            inputPlaceholder: 'Custom Text',
            showCancelButton: false,
            confirmButtonText: 'Preview Design',
            inputValidator: (value) => {
                if ( !value ) {
                    return 'Please Enter Your Custom Text'
                } else if ( value.length > 9 ) {
                    return 'Custom Text Maximum 9 Characters'
                } else if ( value ) {

                    var text = encodeURIComponent(value);

                    return checkProfanity(text).then((response) => {

                        if ( response.profanity ) {
                            return 'Text Not Allowed'
                        }
                    })
                }
            },
            currentProgressStep: 0
        })


        await Queue.fire({
            imageUrl: imageUrlBuilder(bumperType, font, text),
            //input: 'select',
            //inputValue: 'a',
            //inputLabel: 'Choose Different Font',
            confirmButtonText: 'Add To Order',
            inputAttributes: {
                id: 'selectFont'
            },
            inputOptions: {
                'blkout': 'BLKOUT (Default)',
                'oswald': 'OSWALD',
                'forza': 'FORZA',
            },
            didOpen: () => {

                $(".swal2-confirm").hide();

                $(".swal2-image").on('load', function () {

                    $(".swal2-confirm").show();
                });
                /*
                Swal.getInput().addEventListener('change', (event) => {
                    font = event.target.value;
                    var image = imageUrlBuilder(bumperType, font, text)
                    $(".swal2-image").attr("src", image);
                    $(".swal2-confirm").show();
                })
                */

            },
            currentProgressStep: 1
        })


        await Queue.fire({
            icon: 'success',
            title: `Custom Text <br><b>${ text.toUpperCase() }</b><br> Added To Order`,
            confirmButtonText: 'Finish',
            cancelButtonColor: '#EC7732',
            showCancelButton: false,
            /*
            showCancelButton: true,
            cancelButtonText: 'Close',
            input: 'email',
            inputPlaceholder: 'E-Mail Address',
            inputLabel: 'E-mail Custom Design Image (Optional)',

            inputValidator: (value) => {
                if ( !value ) {
                    return 'Invalid E-Mail Address'
                }
            },

             */
            didOpen: () => {
                selectedText = text.toUpperCase();
                $("#customTextSelected").html(`Custom Text <b>${ selectedText }</b> Added`);

            },

            currentProgressStep: 2,
        });

    }

    async function checkProfanity($text) {

        var url = `https://designs.movebumpers.com/check-profanity/${ $text }`;
        return $.get(url);
    }

    function imageUrlBuilder(bumperType, font, text) {

        var urlEncodedText = encodeURIComponent(text);
        return `https://designs.movebumpers.com/create-design/${ bumperType }-${ font }/${ urlEncodedText }`;
    }

    function uuidv4() {
        return ([ 1e7 ] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }


});
